import { executeMutation, executeQuery } from "utils/services/apiServices";
import {
  actionTypes,
  CreateMembershipDurationInput,
  MembershipDurationsProps,
  UpdateMembershipDurationInput,
} from "./actionType";
import { FETCH_MEMBERSHIP_DURATION_BY_PACKAGE_ID } from "../graphql/query";
import {
  CREATE_MEMBERSHIP_DURATION,
  DELETE_MEMBERSHIP_DURATION,
  UPDATE_MEMBERSHIP_DURATION,
} from "../graphql/mutation";
import { showSnackbar } from "utils/snack_bar/store/action";

// fetch membership duration
export const fetchMembershipDurationRequest = () => ({
  type: actionTypes.FETCH_MEMBERSHIP_DURATION_REQUEST,
});

export const fetchMembershipDurationSuccess = (
  payload: MembershipDurationsProps[]
) => ({
  type: actionTypes.FETCH_MEMBERSHIP_DURATION_SUCCESS,
  payload,
});

export const fetchMembershipDurationFail = (payload: string) => ({
  type: actionTypes.FETCH_MEMBERSHIP_DURATION_FAIL,
  payload,
});

export const fetchMembershipDurationByPackageId = (package_id: string) => {
  return async (dispatch: any) => {
    try {
      const input = {
        package_id: package_id,
      };
      await dispatch(fetchMembershipDurationRequest());
      const response = await executeQuery(
        FETCH_MEMBERSHIP_DURATION_BY_PACKAGE_ID,
        input
      );
      const jsonData = response.data?.fetchMembershipDurationWithPackageId;
      if (jsonData?.error === null) {
        dispatch(
          fetchMembershipDurationSuccess(jsonData?.data.membership_durations)
        );
      } else {
        dispatch(fetchMembershipDurationFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchMembershipDurationFail("Failed to fetch duration(s)"));
    }
  };
};

// create membership duration
export const createMembershipDurationRequest = () => ({
  type: actionTypes.CREATE_MEMBERSHIP_DURATION_REQUEST,
});

export const createMembershipDurationSuccess = (
  payload: MembershipDurationsProps
) => ({
  type: actionTypes.CREATE_MEMBERSHIP_DURATION_SUCCESS,
  payload,
});

export const createMembershipDurationFail = (payload: string) => ({
  type: actionTypes.CREATE_MEMBERSHIP_DURATION_FAIL,
  payload,
});

export const createMembershipDuration = (
  createDataInput: CreateMembershipDurationInput
) => {
  return async (dispatch: any) => {
    try {
      dispatch(createMembershipDurationRequest());
      const inputData = {
        input: createDataInput,
      };
      const response = await executeMutation( CREATE_MEMBERSHIP_DURATION, inputData  );
      const jsonData = response.data?.createMembershipDuration;
      if (jsonData?.error === null) {
        dispatch(
          createMembershipDurationSuccess(jsonData?.data.membership_duration)
        );
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(createMembershipDurationFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
      }
    } catch (error: any) {
      dispatch(
        createMembershipDurationFail("Something went wrong, Try again later")
      );
    }
  };
};

// update membership duration
export const updateMembershipDurationRequest = () => ({
  type: actionTypes.UPDATE_MEMBERSHIP_DURATION_REQUEST,
});

export const updateMembershipDurationSuccess = (
  payload: MembershipDurationsProps
) => ({
  type: actionTypes.UPDATE_MEMBERSHIP_DURATION_SUCCESS,
  payload,
});

export const updateMembershipDurationFail = (payload: string) => ({
  type: actionTypes.UPDATE_MEMBERSHIP_DURATION_FAIL,
  payload,
});

export const updateMembershipDuration = (
  updateDataInput: UpdateMembershipDurationInput
) => {
  return async (dispatch: any) => {
    try {
      dispatch(updateMembershipDurationRequest());
      const inputData = {
        input: updateDataInput,
      };
      const response = await executeMutation(
        UPDATE_MEMBERSHIP_DURATION,
        inputData
      );
      const jsonData = response.data?.updateMembershipDuration;
      if (jsonData?.error === null) {
        dispatch(
          updateMembershipDurationSuccess(jsonData?.data.membership_duration)
        );
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(updateMembershipDurationFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
      }
    } catch (error: any) {
      dispatch(
        updateMembershipDurationFail("Something went wrong, Try again later")
      );
    }
  };
};

// delete membership duration
export const deleteMembershipDurationRequest = () => ({
  type: actionTypes.DELETE_MEMBERSHIP_DURATION_REQUEST,
});

export const deleteMembershipDurationSuccess = (payload: string) => ({
  type: actionTypes.DELETE_MEMBERSHIP_DURATION_SUCCESS,
  payload,
});

export const deleteMembershipDurationFail = (payload: string) => ({
  type: actionTypes.DELETE_MEMBERSHIP_DURATION_FAIL,
  payload,
});

export const deleteMembershipDuration = (duration_id: string) => {
  return async (dispatch: any) => {
    try {
      dispatch(deleteMembershipDurationRequest());
      const inputData = {
        duration_id: duration_id,
      };
      const response = await executeMutation(
        DELETE_MEMBERSHIP_DURATION,
        inputData
      );
      const jsonData = response.data?.deleteMembershipDuration;
      if (jsonData?.error === null) {
        dispatch(deleteMembershipDurationSuccess(duration_id));
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(deleteMembershipDurationFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
      }
    } catch (error: any) {
      dispatch(
        deleteMembershipDurationFail("Something went wrong, Try again later")
      );
    }
  };
};
